// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","logo__svg":"Header_logo__svg__0OJW4"};